export default __webpack_public_path__ + "assets/tkoGlamourShot.f50b788f.jpg";